import useGetWebTippsConfigurationInitialValues from './useGetWebTippsConfigurationInitialValues'

export default useGetWebTippsConfigurationInitialValues
